import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Problems } from './components/Problems';
import { Services } from './components/Services';
import { Results } from './components/Results';
import { Pricing } from './components/Pricing';
import { Team } from './components/Team';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-studio-900 text-slate-50 font-sans selection:bg-stream-500/30" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Problems data-id="element-4" />
        <Services data-id="element-5" />
        <Results data-id="element-6" />
        <Pricing data-id="element-7" />
        <Team data-id="element-8" />
        <CTA data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}